<!-- eslint-disable max-len -->
<template lang="pug">
.container
  .breadcrumb-voucher.py-3
  nav(aria-label='breadcrumb')
    ol.breadcrumb
      li.breadcrumb-item
        router-link(to='/')
          Icon.color--info(name='house')
      li.breadcrumb-item
        router-link.color--info(:to='`/${routeHome}`')
          span Emissão de certificado
      li.breadcrumb-item.active
        router-link.color--primary.disabled.fw-600(to='/') Cartão e Token
  .h-large.text-start Emissão Online
  .my-5.text-start
    span #[strong Emitir] ou #[strong Renovar] seu Certificado agora ficou mais #[strong fácil]!
    .my-2 Se você já tem um Certificado em token ou cartão, basta seguir o passo a passo abaixo.
  .mt-5.d-flex.flex-wrap.justify-content-around
    .col-md-4.d-flex.flex-column
      .d-flex
        img(src='@/assets/images/java.svg')
        .flex-column.text-start.p-2
          .h-medium Passo 1
          span Atualizar ou fazer o download do Java em seu computador
      .justify-content-center.align-item-center
        a.btn.btn-outline-info(
          type='button',
          href='https://www.java.com/pt-BR/',
          target='_blank'
        )
          Icon.me-2(name='download')
          span Download do Java
    .col-md-4.d-flex.flex-column
      .d-flex
        img(src='@/assets/images/CertificadoToken.svg')
        .flex-column.text-start.p-2
          .h-medium Passo 2
          span Fazer download da aplicação e executar em seu computador
      .justify-content-end
        a.btn.btn-primary(
          :href='`https://${form.arData.subdomain}.acsoluti.com.br/renovacao/jnlp`',
          type='button'
        )
          Icon.me-2(name='download')
          span Download da aplicação
  .my-5
    .card.p-4
      .row
        .col-6.d-flex.justify-content-center
          img(src='@/assets/images/Etapa1.gif', width='350px', height='270px')
        .col-6.text-start
          .subtitle-large.my-2 Passo 3
          .text-item.pe-1
            div Após executar nossa aplicação #[strong selecione qual o Token ou Cartão deseja utilizar].
            div OBS. É necessário ser um Certificado Digital válido.

            .mt-4 #[strong Digite a senha do dispositivo Token ou Cartão].
            div OBS: A senha requerida ainda NÃO é a senha de emissão e sim a senha do seu dispositivo.

            .mt-4 #[strong Selecione o Certificado] que deseja utilizar para se autenticar.
  .my-5
    .card.p-4
      .row
        .col-6.d-flex.justify-content-center
          img(
            src='@/assets/images/Etapa2.gif',
            style='width: 350px; height: 270px',
            alt='Etapa'
          )
        .col-6.text-start
          .subtitle-large.my-2 Passo 4
          .text-item.pe-1
            .mt-2 #[strong Insira o número do Voucher ou Pedido] e em seguida #[strong preencha os campos obrigatórios.]

            .mt-4 Ainda não tem um voucher ou um número de pedido?
            div Entre em contato conosco e adquira!
            div
              div {{ form.arData.foneAR }}
              div {{ siteArFormatted }}
  .my-5
    .card.p-4
      .row
        .col-6.d-flex.justify-content-center
          img(src='@/assets/images/Etapa3.gif', width='350px', height='270px')
        .col-6.text-start
          .subtitle-large.my-2 Passo 5
          .text-item.pe-1
            .mt-2 #[strong Agora crie a senha de emissão.]

            div IMPORTANTE: #[strong Guarde esta senha], pois não será possível recuperar.
  .my-5
    .card.p-4
      .row
        .col-6.d-flex.justify-content-center
          img(
            src='@/assets/images/doneTokenA3.png',
            width='340px',
            height='195px'
          )
        .col-6.text-start
          .subtitle-large.my-2 Prontinho!
          .text-item.pe-1
            div Após aguardar alguns segundos, você receberá a mensagem que seu Certificado Digital foi aprovado e receberá um e-mail com as instruções para a instalação!
  Contact(style='margin-bottom: 6rem')
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import { mapState } from 'pinia'
  import { useAR, ArDataType } from '@/store/Pinia/useAR.store'

  export default defineComponent({
    name: 'TokenA3View',
    components: {
      Icon,
      Contact,
    },
    data: () => ({
      form: {
        arData: {} as ArDataType,
      },
    }),
    computed: {
      ...mapState(useAR, ['arData']),
      routeHome() {
        return this.form.arData.subdomain ? this.form.arData.subdomain : ''
      },
      siteArFormatted() {
        return this.arData.siteAR
          .replace('http://', '')
          .replace('https://', '')
          .replace('/', '')
      },
    },
    mounted() {
      this.form.arData = this.arData
    },
    beforeMount() {
      setTimeout(() => {
        this.form.arData = { ...this.arData }
      }, 1000)
    },
  })
</script>

<style lang="stylus" scoped>
  .text-item
    font-size: 0.875rem;
</style>
